import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import ReactHtmlParser from "react-html-parser";

import styled from "styled-components";

import Theme from "@airasia/phoenix-components/components/Theme";
import Title from "@airasia/phoenix-components/components/Title";
import Text from "@airasia/phoenix-components/components/Text";
import Image from "@airasia/phoenix-components/components/Image";
import Button from "@airasia/phoenix-components/components/button"

import "../css/main.css";
import { fireGtmEvent, getGtmUserType } from "../utils/functions";

const TabContent = styled.div`
margin:0 auto;

#howtobook-image img{
width:30%;
}

@media only screen and (max-width: 720px) {
  #howtobook-image img{
    width:80%;
}
}
`

const MerchantWrapper = styled.div`
  width: 100%;
  margin: 3em auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align:center;


  @media only screen and (max-width: 720px) {
    width: 100%;
    gap: 10px;
  }
`;

const Merchant = styled.div`
  display: block;
  width:28%;
  margin:1em auto;
  text-align: center;
  background-color:#eb3223;
  border-radius:20px;
  padding:1em;

  #merchant-image, #howtobook-image  {
    background-color: transparent;
    margin:0em auto;
  }
  
  @media only screen and (max-width: 720px) {
    width:100%;
    margin-bottom: 2em;
    margin: 1em auto;

    #merchant-image, #howtobook-image  {
    width:100%;
  }

  }


`;

const TitleWrapperFlex = styled.div`
    margin:0 auto;
    

  #title {
    color: #fff;
    font-weight: 700;
    font-size: 1.2rem;
    margin:10px auto;
  }

  #subtitle{
      line-height:1.5rem;
      display:block;
}

  @media only screen and (max-width: 720px) {
    width: 90%;
    padding-left: 0em;
    padding-right: 0em;

    #title {
      font-size: 1.2rem;
    }
  }
`;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Theme theme="AIRASIA_CLASSIC">
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Theme theme="AIRASIA_CLASSIC">{children}</Theme>
          </Box>
        )}
      </div>
    </Theme>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Theme theme="AIRASIA_CLASSIC">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={value} onChange={handleChange}>
            <Tab label="งานขับรถยนต์อิสระ" {...a11yProps(0)} />
            <Tab label="งานไรเดอร์เงินดี" {...a11yProps(1)} />
            <Tab label="งานแมสเซนเจอร์" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <br />
        <TabPanel value={value} index={0}>
          <TabContent>
          <Image
                  accessible
                  placeHolderBackground="none"
                  customProperties={{
                    id: "howtobook-image",
                  }}
                  src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite-airasia-independent-driver.png"
                  alt="งานขับรถอิสระ"
                />
          <Title
            accessible
            inverted={false}
            textAlign="center"
            type="h2"
            color="primary"
          >
            งานขับรถยนต์อิสระ
          </Title>
          <Text
            accessible
            display="inlineFlex"
            hasToggle={false}
            opacity={1}
            tag="p"
            textAlign="center"
            translation={{}}
            type="default"
          >
            ร่วมเป็นพาร์ทเนอร์คนขับกับ airasia ride งานอิสระที่เลือกรับงานได้ตามวันและเวลาที่สะดวก เพิ่มโอกาสสร้างรายได้แบบไม่มีขีดจำกัด งานเสริมเงินดีที่คนรักการขับรถเช่นคุณพลาดไม่ได้
          </Text>
          </TabContent>

          <MerchantWrapper>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_requirement.png"
                alt="คุณสมบัติของผู้สมัคร"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  คุณสมบัติของผู้สมัคร
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                คุณสมบัติของพาร์ทเนอร์คนขับ airasia ride มีดังนี้:-
                  <ul>
                    <li>อายุ 22 - 60 ปี</li>
                    <li>มีใบขับขี่สาธารณะ</li>
                    <li>อายุการใช้งานรถยนต์ไม่เกิน 9 ปี หากเป็นแท็กซี่ต้องมีอายุการใช้งานไม่เกิน 10 ปี</li>
                    <li>ยอมรับเงื่อนไขและข้อกำหนดของแอร์เอเชีย และยินยอมจ่ายค่าคอมมิชชั่น 15% ให้กับแอร์เอเชีย</li>
                    <li>ไม่เคยต้องโทษจำคุกหรือมีความผิดทางอาญา</li>
                  </ul>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_benefits.png"
                alt="สิทธิประโยชน์ที่พลาดไม่ได้"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  สิทธิประโยชน์ที่พลาดไม่ได้
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  ค่าตอบแทนและสิทธิประโยชน์สำหรับพาร์ทเนอร์คนขับ airasia ride
                  <ol>
                  <li>ยิ่งขยันยิ่งได้มาก รายได้ 8,000-25,000+ ต่อเดือน (ขึ้นอยู่กับการรับงาน)</li>
                  <li>อิสระขับเมื่อไหร่ก็ได้</li>
                  <li>สามารถถอนเงินได้ทุกวัน</li>
                  <li>มีเทรนนิ่งสำหรับพาร์ทเนอร์คนขับ</li>
                  </ol>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_register.png"
                alt={props.Tab1title3}
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  ขั้นตอนการสมัคร
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  color="default"
                  type="p"
                  customProperties={{ id: "subtitle" }}
                >
                  สมัครเป็นพาร์ทเนอร์คนขับ แอร์เอเชีย ไรด์ ได้ง่ายๆ ตามขั้นตอนดังต่อไปนี้:-
                  <br />
                  <ol>
                    <li>กรอกข้อมูล</li>
                    <li>อัพโหลดเอกสารผ่านแอพ airasia ride Driver</li>
                  </ol>
                  * หากเอกสารได้รับการอนุมัติแล้ว คุณจะได้รับการแจ้งเตือนเพื่อดำเนินการในลำดับถัดไป
                  <br />
                  * หากรายละเอียดไม่ครบถ้วนหรือสมบูรณ์ คุณจะได้รับแจ้งเตือนผ่าน SMS
                  <br />* สามารถเช็คสถานะการสมัครเป็นพาร์ทเนอร์คนขับแอร์เอเชียได้โดยตรงผ่านแอพ airasia ride Driver
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: "ctaButton",
                      paddingBottom: "0.7rem",
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      paddingTop: "0.7rem"
                    }}
                    size="normal"
                    color="primary"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                        "eventDetails.category": "Ride | Request Here",
                        "eventDetails.action": "click",
                        "eventDetails.label": `independent drider | ${getGtmUserType()}`
                      })
                      window.open("https://form.jotform.com/222510714460445")
                    }}
                  >
                    สมัครขับรถ airasia ride
                  </Button>
          </MerchantWrapper>
        </TabPanel>
        <TabPanel value={value} index={1}>
        <TabContent>
          <Image
                  accessible
                  placeHolderBackground="none"
                  customProperties={{
                    id: "howtobook-image",
                  }}
                  src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite-airasia-full-time-rider.png"
                  alt="งานไรเดอร์เงินดี"
                />
          <Title
            accessible
            inverted={false}
            textAlign="center"
            type="h2"
            color="primary"
          >
            งานไรเดอร์เงินดี
          </Title>
          <Text
            accessible
            display="inlineFlex"
            hasToggle={false}
            opacity={1}
            tag="p"
            textAlign="center"
            translation={{}}
            type="default"
          >
            มีมอเตอร์ไซค์ก็ทำเงินได้ไม่แพ้กัน สมัครเป็นไรเดอร์ขับรถส่งอาหาร Delivery กับ airasia food รับรายได้เสริมได้สูงสุด 5,000 บาทต่อสัปดาห์ แค่ส่งเดลิเวอรี่อาหารก็ทำเงินได้แบบเพลินๆ 
          </Text>
          </TabContent>

          <MerchantWrapper>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_requirement.png"
                alt="คุณสมบัติของผู้สมัคร"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  คุณสมบัติของผู้สมัคร
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                คุณสมบัติของไรเดอร์พาร์ทเนอร์ส่งอาหาร airasia food มีดังนี้:-
                  <ul>
                  <li>อายุ 18 ปีขึ้นไป</li>
                  <li>มีรถจักรยานยนต์</li>
                  <li>มีใบขับขี่รถจักรยานยนต์</li>
                  <li>ตรวจเช็คสภาพรถและความพร้อมในการใช้งานของรถจักรยานยนต์</li>
                  <li>ยอมรับเงื่อนไขและข้อกำหนดของแอร์เอเชีย และยินยอมจ่ายค่าคอมมิชชั่น 15% ให้กับแอร์เอเชีย</li>
                  <li>ไม่เคยต้องโทษจำคุกหรือมีความผิดทางอาญา</li>
                  </ul>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_benefits.png"
                alt="สิทธิประโยชน์ที่พลาดไม่ได้"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  สิทธิประโยชน์ที่พลาดไม่ได้
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  <ol>
                    <li>ยิ่งขยันยิ่งได้มาก รายได้สูงสุด 5,000 ต่อสัปดาห์ (ขึ้นอยู่กับการรับงาน)</li>
                    <li> อิสระขับเมื่อไหร่ก็ได้</li>
                    <li> สามารถถอนเงินได้ทุกวัน</li>
                    <li> มีเทรนนิ่งสำหรับพาร์ทเนอร์ส่งอาหาร</li>
                  </ol>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_register.png"
                alt={props.Tab1title3}
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  ขั้นตอนการสมัคร
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  color="default"
                  type="p"
                  customProperties={{ id: "subtitle" }}
                >
                  สมัครเป็นไรเดอร์ พาร์ทเนอร์ส่งอาหารกับ แอร์เอเชีย ฟู้ด ได้ง่ายๆ ตามขั้นตอนดังต่อไปนี้:-
                  <br />
                  <ol>
                    <li>ลงทะเบียนเพื่อเป็นพาร์ทเนอร์คนขับกับ airasia Super App <a href="https://form.jotform.com/222152536739054" style="color:#fff">ที่นี่</a></li>
                    <li>อกรอกข้อมูลให้ครบถ้วน</li>
                  </ol>
                  * หลังจากลงทะเบียนเรียบร้อยแล้ว ทางเราจะใช้เวลาตรวจสอบ 1 - 3 วันและติดต่อกลับไปโดยเร็วที่สุด
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: "ctaButton",
                      paddingBottom: "0.7rem",
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      paddingTop: "0.7rem"
                    }}
                    size="normal"
                    color="primary"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                        "eventDetails.category": "Ride | Request Here",
                        "eventDetails.action": "click",
                        "eventDetails.label": `independent rider | ${getGtmUserType()}`
                      })
                      window.open("https://form.jotform.com/222152536739054")
                    }}
                  >
                   สมัครเป็นไรเดอร์
                  </Button>
          </MerchantWrapper>
        </TabPanel>
        <TabPanel value={value} index={2}>
        <TabContent>
          <Image
                  accessible
                  placeHolderBackground="none"
                  customProperties={{
                    id: "howtobook-image",
                  }}
                  src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite-airasia-full-time-rider.png"
                  alt="งานแมสเซนเจอร์"
                />
          <Title
            accessible
            inverted={false}
            textAlign="center"
            type="h2"
            color="primary"
          >
            งานแมสเซนเจอร์
          </Title>
          <Text
            accessible
            display="inlineFlex"
            hasToggle={false}
            opacity={1}
            tag="p"
            textAlign="center"
            translation={{}}
            type="default"
          >
            หากคุณหางานขับรถส่งของรายได้ดีและมีรถจักรยานยนต์เป็นของตัวเอง สมัครเป็นแมสเซนเจอร์ส่งของกับ airasia xpress วันนี้แล้วหาเงินเพิ่มในเวลาว่างได้เลย
          </Text>
          </TabContent>

          <MerchantWrapper>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_requirement.png"
                alt="คุณสมบัติของผู้สมัคร"
              />
<br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  คุณสมบัติของผู้สมัคร
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  คุณสมบัติของแมสเซนเจอร์พาร์ทเนอร์ส่งพัสดุ airasia xpress มีดังนี้:-
                  <ol>
                    <li>อายุ 18 ปีขึ้นไป</li>
                    <li>มีรถจักรยานยนต์</li>
                    <li>มีใบขับขี่รถจักรยานยนต์</li>
                    <li>ตรวจเช็คสภาพรถและความพร้อมในการใช้งานของรถจักรยานยนต์</li>
                    <li>ยอมรับเงื่อนไขและข้อกำหนดของแอร์เอเชีย และยินยอมจ่ายค่าคอมมิชชั่น 15% ให้กับแอร์เอเชีย</li>
                    <li>ไม่เคยต้องโทษจำคุกหรือมีความผิดทางอาญา</li>
                    </ol>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_benefits.png"
                alt="สิทธิประโยชน์ที่พลาดไม่ได้"
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  สิทธิประโยชน์ที่พลาดไม่ได้
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  type="p"
                  color="default"
                  customProperties={{ id: "subtitle" }}
                >
                  ค่าตอบแทนและสิทธิประโยชน์สำหรับแมสเซนเจอร์พาร์ทเนอร์ส่งพัสดุ airasia xpress
                  <ol>
                    <li>ยิ่งขยันยิ่งได้มาก (ขึ้นอยู่กับการรับงาน)</li>
                    <li> อิสระขับเมื่อไหร่ก็ได้</li>
                    <li>มีเทรนนิ่งสำหรับพาร์ทเนอร์ส่งพัสดุ</li>
                  </ol>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Merchant>
              <Image
                accessible
                width="80%"
                customProperties={{
                  id: "howtobook-image",
                }}
                src="https://www.airasia.com/aa/driver-rider/images/Rider-Recruite_register.png"
                alt={props.Tab1title3}
              />
              <br />
              <TitleWrapperFlex style={{ display: "block" }}>
                <Title
                  accessible
                  inverted={false}
                  textAlign="center"
                  type="h2"
                  customProperties={{ id: "title" }}
                >
                  ขั้นตอนการสมัคร
                </Title>
                <Text
                  accessible
                  inverted={false}
                  textAlign="left"
                  color="default"
                  type="p"
                  customProperties={{ id: "subtitle" }}
                >
                  สมัครเป็นแมสเซนเจอร์ พาร์ทเนอร์ส่งของและพัสดุกับ airasia xpress ได้ง่ายๆ ตามขั้นตอนดังต่อไปนี้:-
                  <br />
                  <ol>
                    <li>ลงทะเบียนเพื่อเป็นพาร์ทเนอร์คนขับกับ airasia Super App <a href="https://form.jotform.com/222152536739054" style="color:#fff">ที่นี่</a></li>
                    <li>กรอกข้อมูลให้ครบถ้วน</li>
                  </ol>
                  * หลังจากลงทะเบียนเรียบร้อยแล้ว ทางเราจะใช้เวลาตรวจสอบ 1 - 3 วันและติดต่อกลับไปโดยเร็วที่สุด <br/>
                </Text>
              </TitleWrapperFlex>
            </Merchant>
            <Button
                    accessible
                    buttonType="button"
                    boxShadow
                    customProperties={{
                      id: "ctaButton",
                      paddingBottom: "0.7rem",
                      paddingLeft: "3rem",
                      paddingRight: "3rem",
                      paddingTop: "0.7rem"
                    }}
                    size="normal"
                    color="primary"
                    backgroundColor="default"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": 'trackEventNoEcommerce',
                        "eventDetails.category": "Ride | Request Here",
                        "eventDetails.action": "click",
                        "eventDetails.label": `fulltime rider | ${getGtmUserType()}`
                      })
                      window.open("https://form.jotform.com/222152536739054")
                    }}
                  >
                    สมัครเป็นแมสเซนเจอร์
                  </Button>
          </MerchantWrapper>
        </TabPanel>
      </Box>
    </Theme>
  );
}
